<template>
	<v-card class='elevation-0 agenda-page agenda-page-container page'>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<Agendas v-else-if="isBlocked !== null" />
	</v-card>
</template>

<script>
import Agendas from '@/components/Event/Agendas.vue';
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
export default {
	mixins: [Block],
	components: {
		Agendas,
		PageBlocked
	},
	data() {
		return {
			pageBlockedName: 'events'
		}
	},
	computed: {
		...mapGetters('event', ['event']),

		eventIsEmpty() {
			return _.isEmpty(this.event)
		}
	},
	methods: {
		...mapActions('event', ['getEvent'])
	},
	created() {
		if (this.eventIsEmpty) {
			this.$router.push({
				name: 'event-by-id',
				params: {id: this.$route.params.id}
			})
		}
	}
}
</script>
<style lang="scss">
.agenda-page {
	@media (max-width: 768px) {
		padding-top: 4px;
	}
}
</style>